const env = {
  url: 'http://www.soaresdemirandaeandre.com/',
  app_url: 'http://www.soaresdemirandaeandre.com/admin',
  token: '2b553cc4ded79588104e7367ffb23a',
};

export default env;



// WEBPACK FOOTER //
// ./src/config/env.js